'use client';

import { map } from 'lodash';
import * as Accordion from '@/components/ui/Accordion';
import { HtmlBlock } from '@/components/ui/HtmlBlock';
import { FaqItem } from '@/graphql/queries/pages/compromisso-asg/types';
import { cn } from '@/utils/mergeClassName';
import { onlyTextTags } from '@/utils/onlyTextTags';

type FaqProps = {
  enableBackgroundColor?: boolean;
  items: FaqItem[];
};

export const Faq = ({ items, enableBackgroundColor = false }: FaqProps) => {
  return (
    <section
      className={cn(
        'flex flex-col gap-10 bg-white px-6 py-12 lg:p-20',
        enableBackgroundColor ? 'bg-grey-200' : 'bg-white'
      )}
    >
      <Accordion.Root type="single" collapsible>
        {map(items, (faq) => (
          <Accordion.Item key={faq.id} value={`item-${faq.id}`}>
            <Accordion.Trigger className="bg-white px-8 py-6 text-start font-bold text-grey-800 shadow-grey-200 data-[state=open]:bg-grey-100 data-[state=open]:text-blue-400">
              {faq.title}
            </Accordion.Trigger>
            <Accordion.Content className="bg-white py-6 pl-6 pr-8 text-base font-regular text-grey-800 ">
              <HtmlBlock html={onlyTextTags(faq.description)} className="text-grey-800" />
            </Accordion.Content>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </section>
  );
};
